import { Component } from 'vue-property-decorator';
import Base from '@/Base';

@Component
export default class BaseForm extends Base {
    constructor() {
        super();
    }
}
